import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_NavModeUpdated = new ThunderDispatcher('__onNavModeUpdated');
//# sourceMappingURL=dispatchers.js.map